import { Component, OnInit, ViewChild, PLATFORM_ID, Inject } from '@angular/core';

import { FormGroup, FormBuilder } from '@angular/forms';
import { AuthSandbox } from '../../../core/auth/auth.sandbox';
import { CommonSandbox } from '../../../core/common/common.sandbox';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../core/common/common.service';
import { ActivatedRoute } from '@angular/router';
import { NgxPaypalComponent, PayPalScriptService } from 'ngx-paypal';
import { PaymentService } from '../../../core/payment/payment.service';
import { Router } from '@angular/router';
import { Location, isPlatformBrowser } from '@angular/common';


@Component({
	selector: 'app-subscription-update',
	templateUrl: './subscription-update.component.html',
	styleUrls: ['./subscription-update.component.scss']
})
export class SubscriptionUpdateComponent implements OnInit {

	public showPay = true;
	public payPalConfig: any;
	public paymentisterForm: FormGroup;
	public submitted = false;
	public countries = [];
	public services = [];
	public activeServiceId = 0;
	public selectedServiceId = 0;
	public activeService: any;
	public serviceTitle = '';
	public serviceAmount = 0;
	public serviceId = 0;
	public vendorId = 0;
	public cancleService = 0;
	public alreadyService = 0;
	public activeServiceData: any = {};
	public loading = false;
	public currentUser: any = null;
	@ViewChild('payPalElem1') paypalComponent1?: NgxPaypalComponent;

	constructor(public formBuilder: FormBuilder, @Inject(PLATFORM_ID) private platformId: Object, public authSandbox: AuthSandbox, public commonSandbox: CommonSandbox,
		private toastr: ToastrService,
		private commonService: CommonService,
		private route: ActivatedRoute,
		public paymentService: PaymentService,
		public payPalScriptService: PayPalScriptService,
		private router: Router,
		private location: Location,

	) { }

	ngOnInit() {
		if (isPlatformBrowser(this.platformId)) {
			this.currentUser = JSON.parse(localStorage.getItem('vendorUser'));
		}
		console.log("this current user");
		console.log(this.currentUser);
		if (!this.currentUser) {
			this.router.navigate(['auth/login']);
		}

		this.userServices();
		this.getactiveServices();
	}

	getactiveServices() {
		this.commonService.getVendorActiveSubscription({}).toPromise().then(response => {
			console.log('vendor active service', response.data);
			this.activeService = response.data;

			console.log("this.activeService");
			console.log(this.activeService);


			if (this.activeService) {
				this.alreadyService = 1;

				if (parseInt(this.activeService.amount) == 0) {
					this.activeServiceId = 0;
					this.selectedServiceId = 0;
				} else {
					this.activeServiceId = this.activeService.serviceId;
					if (this.activeService.status == 0) {
						this.selectedServiceId = this.activeService.serviceId;
					}
				}
			}

		});
	}

	cancleVendorService() {
		const params: any = {};
		params.vendorPaymentId = this.activeService.id;
		this.loading = true;
		this.commonService.cancleVendorService(params).toPromise().then((response) => {
			this.cancleService = 0;
			this.loading = false;
			this.toastr.success("Subscription cancelled successfully");
			this.router.navigate(['dashboard']);
		})
	}

	updateVendorSubscription() {

		if (!this.selectedServiceId) {
			return this.toastr.error("Please choose a plan");
		}

		const params: any = {};

		params.selectedServiceId = this.selectedServiceId;
		if ((this.activeServiceId == this.selectedServiceId) && (this.activeService.status == 1)) {
			this.toastr.error("Please choose another plan");
		} else {
			if (this.activeServiceData.price == 0.00) {
				const params: any = {};
				params.serviceId = this.activeServiceData.serviceId;
				params.serviceName = this.activeServiceData.serviceTitle;
				params.price = this.activeServiceData.price;
				params.vendorId = this.currentUser.customerId;

				this.commonService.updateVendorPayment(params).toPromise().then(response => {
					this.loading = false;
					this.toastr.success('You plan updated successfully');
					this.router.navigate(['dashboard']);
				});
			} else {
				this.router.navigate(['auth/vendor-payment'], { queryParams: { id: this.selectedServiceId, uid: this.currentUser.vendorId, type: 1 } });
			}
		}
	}

	userServices() {
		const params: any = {};

		params.limit = 10;
		params.offset = 0;

		this.commonService.getServicesForUsers(params).toPromise().then(response => {
			this.services = response.data;
			console.log("services of respmnsoie", this.services);
		});
	}

	selectService(id, service) {
		this.activeServiceData = service;
		if (this.alreadyService && (parseInt(service.price) == 0)) {
			console.log("not allowed", id);
			this.activeServiceId = 0;
		} else {
			this.selectedServiceId = id;
		}
	}

	public changeCountry(e) {
		console.log(" *****  e.target.value", e);
	}

	public changeCategory(e) {
		console.log(" *****  e.target.value", e);
	}

	goBack() {
		// window.history.back();
		this.location.back();

		console.log('goBack()...');
	}


}
